import * as React from "react"

import { Search } from "lucide-react"

import { Input, type InputProps } from "../Input/Input"

export type SearchInputProps = Omit<
  InputProps,
  "type" | "startAdornment" | "endAdornment" | "onClear"
> & {
  onClear: () => void
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ onClear, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="search"
        startAdornment={<Search />}
        onClear={onClear}
        {...props}
      />
    )
  },
)

SearchInput.displayName = "SearchInput"

export { SearchInput }
